import { render, staticRenderFns } from "./MarketOverallIncome.vue?vue&type=template&id=1b6bfd5b"
import script from "./MarketOverallIncome.vue?vue&type=script&lang=js"
export * from "./MarketOverallIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports